import { Link, NavLink } from 'react-router-dom';
import { Phone, Menu, MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTrigger, SheetClose, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { BUSINESS, NAV_LINKS } from '@/lib/constants';

export default function Header() {
  return (
    <header className="sticky top-0 z-40 border-b" style={{ background: 'rgba(16,97,95,0.06)', backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)' }}>
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-2 shrink-0" data-testid="header-logo-link">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-primary-foreground font-display font-bold">IR</span>
          <span className="flex flex-col leading-tight">
            <span className="font-display font-semibold text-base sm:text-lg whitespace-nowrap">{BUSINESS.name}</span>
            <span className="text-[10px] sm:text-xs text-muted-foreground -mt-0.5 whitespace-nowrap">{BUSINESS.tagline}</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to.replace('/', '')}`}
              className={({ isActive }) =>
                `px-2.5 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                  isActive ? 'text-primary bg-secondary' : 'text-foreground/80 hover:text-primary hover:bg-secondary/60'
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Button asChild size="icon" variant="outline" className="hidden sm:inline-flex" data-testid="header-whatsapp-button" aria-label="WhatsApp Island Ride">
            <a href={BUSINESS.whatsappUrl} target="_blank" rel="noreferrer">
              <MessageCircle className="h-4 w-4" />
            </a>
          </Button>
          <Button asChild size="icon" variant="outline" className="hidden sm:inline-flex" data-testid="header-call-button" aria-label={`Call ${BUSINESS.phone}`}>
            <a href={BUSINESS.phoneTel}>
              <Phone className="h-4 w-4" />
            </a>
          </Button>
          <Button asChild variant="ghost" className="hidden md:inline-flex bg-accent text-primary hover:bg-accent/80" data-testid="header-request-link">
            <Link to="/request-a-ride">Request a Ride</Link>
          </Button>

          <Sheet>
            <SheetTrigger asChild>
              <Button variant="outline" size="icon" className="lg:hidden" aria-label="Open menu" data-testid="mobile-nav-open-button">
                <Menu className="h-5 w-5" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px] bg-background">
              <SheetHeader>
                <SheetTitle className="font-display">Menu</SheetTitle>
              </SheetHeader>
              <div className="mt-4 flex flex-col gap-1">
                {NAV_LINKS.map((l) => (
                  <SheetClose asChild key={l.to}>
                    <NavLink
                      to={l.to}
                      data-testid={`mobile-nav-link-${l.to.replace('/', '')}`}
                      className={({ isActive }) =>
                        `px-3 py-3 rounded-md text-base font-medium ${
                          isActive ? 'text-primary bg-secondary' : 'text-foreground hover:bg-secondary/60'
                        }`
                      }
                    >
                      {l.label}
                    </NavLink>
                  </SheetClose>
                ))}
                <div className="mt-3 grid gap-2">
                  <SheetClose asChild>
                    <Button asChild data-testid="mobile-menu-call-button">
                      <a href={BUSINESS.phoneTel}><Phone className="h-4 w-4" /><span className="ml-1.5">Call {BUSINESS.phone}</span></a>
                    </Button>
                  </SheetClose>
                  <SheetClose asChild>
                    <Button asChild variant="secondary" data-testid="mobile-menu-request-link">
                      <a href="/request-a-ride">Request a Ride</a>
                    </Button>
                  </SheetClose>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
